import Layout from '@/layout'

const voucherManagerRoutes = [{
    path: '/voucherManager',
    component: Layout,
    children: [{
        path: 'index',
        name: 'voucherManager',
        component: () =>
            import ('@/views/voucherManager/index'),
        meta: {
            title: '卡券管理',
            icon: 'component',
        }
    }]
}, ]

export default voucherManagerRoutes
